import React, { useState } from 'react';
import FlippableCard from '../../components/FlippableCard/FlippableCard';
import { KeyPillarsConfig } from './config';
import './KeyPillars.css';

const KeyPillars = () => {
  const [activeCardIndex, setActiveCardIndex] = useState(null);

  const handleCardFlip = (index) => {
    // Toggle the clicked card, or close if already open
    setActiveCardIndex(prev => prev === index ? null : index);
  };

  return (
    <section className="key-pillars-section">
      <div className="key-pillars-container">
        <h2 className="key-pillars-title">KEY PILLARS</h2>
        <div className="key-pillars-cards-row">
          {KeyPillarsConfig.map((card, index) => (
            <FlippableCard
              key={index}
              icon={card.icon}
              title={card.title}
              description={card.description}
              points={card.points}
              isFlipped={activeCardIndex === index}
              onFlip={() => handleCardFlip(index)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default KeyPillars;
